import noImagePlaceholder from "../../assets/images/romotors-no-image-available-notext.jpg";
import { useEffect, useRef, useState } from "react";
import BreadCrumbs from "../../components/General/BreadCrumbs";
import ShowroomsList from "../../components/Showrooms/ShowroomsList";
import LoadingSkeleton from "../../components/UI/LoadingSkeleton";
import BrandsList from "../../components/Vehicles/BrandsList";
import SingleVehicleCard from "../../components/Vehicles/SingleVehicleCard";
import {
  getBannersFiltered,
  getBrandsFor,
  getNewVehicles,
  getNewVehiclesOffers,
  getShowroomsFor,
  ShowroomResource,
} from "../../utils/fetcher";
import FindVehicleFilter from "../../components/Vehicles/FindVehicleFilter";
import SidebarBox from "../../components/General/SidebarBox";
import { VehicleNames } from "../../utils/GeneralTypes";
import style from "./index.module.css";
import { useScrollToTop } from "../../utils/generalUtils";
import Banner from "../../components/Vehicles/Banner";
import { useTranslation } from "../../hooks/useTranslation";

// TODO: add types
type ComponentDataT = {
  showrooms: ShowroomResource[] | null;
  brands: any;
  recent: any;
  offers: any;
  banners: any;
};
const NewVehicles = ({ vehicleNames }: ComponentPropsType) => {
  const { locale } = useTranslation();

  const initialMount = useRef<boolean>(true);

  useScrollToTop();

  const [componentData, setComponentData] = useState<{
    isFetching: boolean;
    data: ComponentDataT;
  }>({
    isFetching: true,
    data: {
      showrooms: null,
      brands: null,
      recent: null,
      offers: null,
      banners: null,
    },
  });

  useEffect(() => {
    if (!initialMount.current) {
      setComponentData((current) => ({
        ...current,
        isFetching: true,
      }));
    }
    initialMount.current = false;
    let data: ComponentDataT = {
      showrooms: null,
      brands: null,
      recent: null,
      offers: null,
      banners: null,
    };
    (async () => {
      const res = await Promise.all([
        getShowroomsFor(vehicleNames.single, "?number=4"),
        getBrandsFor("new", vehicleNames.single),
        getNewVehicles(vehicleNames.single, "?number=3"),
        getNewVehiclesOffers(vehicleNames.single, "?number=3"),
        getBannersFiltered(`new_${vehicleNames.plural}`),
      ]);
      data.showrooms = res[0].data.showrooms.data;
      data.brands = res[1]?.data?.brands;
      data.recent = res[2]?.data?.vehicles?.data;
      data.offers = res[3]?.data?.vehicles?.data;
      data.banners = res[4]?.data?.banners;
      setComponentData({
        isFetching: false,
        data,
      });
    })();
  }, [vehicleNames]);

  return (
    <>
      {/* <div className="main_section">
        <div className="container-lg">
          <div className="section_content_padding">
            <BreadCrumbs
              pages={[
                { text: locale("home"), link: "/" },
                {
                  text: locale(`new_${vehicleNames.plural}`),
                  link: "",
                },
              ]}
            />
          </div>
        </div>
      </div> */}
      <div className="main_section">
        <div className="container-lg">
          <div className="section_content_padding">
            <div className={`${style.page_row} row`}>
              <div className="col-lg-4">
                <SidebarBox>
                  <FindVehicleFilter
                    vehicleNames={vehicleNames}
                    vehicleCondition="new"
                    searchBaseUrl={`/distributor/${vehicleNames.plural}/find`}
                  />
                </SidebarBox>
              </div>
              <div className="col-lg-8">
                {componentData.data.banners && componentData.data.banners.length > 0 && (
                  <div style={{ marginBottom: "20px" }}>
                    <Banner
                      banners={componentData.data.banners.map((banner: any) => ({
                        image: banner.image,
                        url: banner.link,
                      }))}
                      bannerStyle="small"
                      redirection="newPage"
                    />
                  </div>
                )}
                {((!componentData.isFetching && componentData.data.showrooms!.length > 0) ||
                  componentData.isFetching) && (
                  <div className={style.page_section}>
                    <h3 className="main_section__title main_section__title--small">{locale("featured_showrooms")}</h3>
                    <div className={style.page_sub_section}>
                      {componentData.isFetching ? (
                        <LoadingSkeleton count={5} />
                      ) : (
                        <ShowroomsList
                          showrooms={componentData.data.showrooms!.map((showroom: any) => ({
                            name: showroom.name,
                            image: showroom.logo,
                            link: `/showrooms/showroom/${showroom.id}`,
                          }))}
                        />
                      )}
                    </div>
                  </div>
                )}
                {((componentData.data.brands?.length > 0 && !componentData.isFetching) || componentData.isFetching) && (
                  <>
                    <div className={style.page_section}>
                      <div className="section_content_padding">
                        <div className="section_separator"></div>
                      </div>
                    </div>
                    <div className={style.page_section}>
                      <h3 className="main_section__title main_section__title--small">{locale("find_your_brand")}</h3>
                      <div className={style.page_sub_section}>
                        {componentData.isFetching ? (
                          <LoadingSkeleton count={5} />
                        ) : (
                          <BrandsList
                            isExpandable={false}
                            brands={componentData.data.brands.map((brand: any) => ({
                              link: `/new-${vehicleNames.plural}/find?brand=${brand.id}`,
                              image: brand.logo,
                              name: brand.name,
                            }))}
                          />
                        )}
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      {((componentData.data.recent?.length > 0 && !componentData.isFetching) || componentData.isFetching) && (
        <>
          <div className="main_section">
            <div className="container-lg">
              <div className="section_content_padding">
                <div className="section_separator"></div>
              </div>
            </div>
          </div>
          <div className="main_section" style={{ marginTop: "30px" }}>
            <div className="container-lg">
              <div className="section_content_padding">
                <h3 className="main_section__title main_section__title--small main_section__title--center">
                  {locale("recently_added")}
                </h3>
                <div className={style.page_sub_section}>
                  {componentData.isFetching ? (
                    <LoadingSkeleton count={5} />
                  ) : (
                    <>
                      <div className={`${style.all_vehicles__row} row`}>
                        {componentData.data.recent.map((vehicle: any) => (
                          <div key={vehicle.id} className="col-md-4 col-sm-6">
                            <SingleVehicleCard
                              brand={{
                                image: vehicle?.model?.brand?.logo,
                                link: `new-${vehicleNames.plural}/brands/${vehicle?.model?.brand?.id}`,
                                name: vehicle?.model?.brand?.name,
                              }}
                              has_discount={vehicle.has_discount}
                              has_free_maintenance={vehicle?.has_free_maintenance}
                              image={vehicle?.model?.image}
                              link={`/distributor/${vehicleNames.plural}/${vehicleNames.single}/${vehicle.id}`}
                              model={vehicle?.model?.name}
                              old_price={vehicle?.old_price}
                              price={vehicle.price}
                              year={vehicle?.model?.year}
                              selling_flag={vehicle?.selling_flag}
                            />
                          </div>
                        ))}
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </>
      )}
      {((componentData.data.offers?.length > 0 && !componentData.isFetching) || componentData.isFetching) && (
        <>
          <div className="main_section" style={{ marginTop: "30px" }}>
            <div className="container-lg">
              <div className="section_content_padding">
                <div className="section_separator"></div>
              </div>
            </div>
          </div>
          <div className="main_section" style={{ marginTop: "30px" }}>
            <div className="container-lg">
              <div className="section_content_padding">
                <h3 className="main_section__title main_section__title--small main_section__title--center">
                  {locale("new_offers")}
                </h3>
                <div className={style.page_sub_section}>
                  {componentData.isFetching ? (
                    <LoadingSkeleton count={5} />
                  ) : (
                    <>
                      <div className={`${style.all_vehicles__row} row`}>
                        {componentData.data.offers.map((vehicle: any) => (
                          <div key={vehicle.id} className="col-md-4 col-sm-6">
                            <SingleVehicleCard
                              brand={{
                                image: vehicle?.model?.brand?.logo,
                                link: `new-${vehicleNames.plural}/brands/${vehicle?.model?.brand?.id}`,
                                name: vehicle?.model?.brand?.name,
                              }}
                              has_discount={vehicle.has_discount}
                              has_free_maintenance={vehicle?.has_free_maintenance}
                              image={vehicle.images[0]?.image || noImagePlaceholder}
                              link={`/new-${vehicleNames.plural}/${vehicleNames.single}/${vehicle.id}`}
                              model={vehicle?.model?.name}
                              old_price={vehicle?.old_price}
                              price={vehicle.price}
                              year={vehicle?.model?.year}
                              selling_flag={vehicle?.selling_flag}
                            />
                          </div>
                        ))}
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default NewVehicles;

type ComponentPropsType = {
  vehicleNames: VehicleNames;
};
